import React, { useState } from 'react'
import { Form } from 'antd'
import { QuestionnaireItem } from '@medplum/fhirtypes'
import { Extension } from '@medplum/fhirtypes'
import { debounce } from 'lodash'
import { useAssessmentContext } from 'contexts/AssessmentContext'
import { QuestionnaireAnswerType } from 'components/Assessments/assessmentType'
import SanitizedTextArea from 'components/Common/Input/SanitizedTextArea'
import { findComponentExtensionAndReturnDisplay } from '../helpers'
import {
  useValidateAndUpdateValues,
  ValidateFormValuesType
} from '../PatAssessment/hooks/useValidateAndUpdateFormValues'
export interface QuestionDetailsSingleSelectProps {
  question: QuestionnaireItem
}

export const QuestionItemTextArea: React.FC<QuestionDetailsSingleSelectProps> = ({ question }) => {
  const [value, setValue] = useState('')
  const { answers } = useAssessmentContext()
  const validateAndUpdateFormValues = useValidateAndUpdateValues()
  const debouncedSetItems = debounce((newItem) => {
    validateAndUpdateFormValues(newItem)
  }, 300)

  let questionLinkId
  let questionText
  if (typeof question.linkId === 'string') {
    questionLinkId = question.linkId
  }
  if (typeof question.text === 'string') {
    questionText = question.text
  }

  const placeholderText = question.extension
    ? findComponentExtensionAndReturnDisplay(question.extension as Extension[])
    : 'Add a comment'

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
    const inputValue = e.target.value
    setValue(inputValue)

    const newResponseItem: ValidateFormValuesType = {
      type: question.type as QuestionnaireAnswerType,
      linkId: questionLinkId,
      text: questionText,
      value: inputValue
    }
    debouncedSetItems(newResponseItem)
  }

  const renderQuestions = (): JSX.Element => {
    return (
      <Form.Item
        name={questionLinkId}
        rules={[{ required: question.required || undefined, message: 'Answer required' }]}
        initialValue={answers[questionLinkId]?.valueString}
      >
        <SanitizedTextArea
          value={value}
          onChange={handleChange}
          placeholder={placeholderText}
          autoSize={{ minRows: 4, maxRows: 8 }}
        />
      </Form.Item>
    )
  }

  return renderQuestions()
}
